export const defaultVortexTheme = {
  primary: "#09B2C9",
  accentColor: "linear-gradient(to right, #6A25C0, #09B2C9)",
  button: "linear-gradient(to bottom, #6A25C0, #09B2C9)",
  primarytextcolor: "#09B2C9",
  secondarytextcolor: "#6A25C0",
}
